import { render, staticRenderFns } from "./nursePresAddWy.vue?vue&type=template&id=3da1b032&"
import script from "./nursePresAddWy.vue?vue&type=script&lang=ts&"
export * from "./nursePresAddWy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports